import { Form, Button, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import moment from "moment";

import email1 from "../../assets/images/email-setup/email-1.svg";
import email2 from "../../assets/images/email-setup/email-2.svg";
import email3 from "../../assets/images/email-setup/email-3.svg";
import email4 from "../../assets/images/email-setup/email-4.svg";
import gmail from "../../assets/images/auth/gmail.svg";
import outlook from "../../assets/images/email-setup/outlook.png";
import smtp from "../../assets/images/email-setup/SMTP.png";
import AccountManagement from "./AccountManagement";
import SMTPEmail from "./SMTPEmail";
import { useAuth } from "./hooks/useAuth";
import { EmailContext } from "../../context/EmailContext";
import Loader from "../loader";
import SubscriptionModal from "../web2lead/SubscriptionModal";
import { getSubscriptionUserInfo } from "../../utils/utils";

const items = [
  {
    icon: email1,
    text: "Monitor email opens and click activity",
  },
  {
    icon: email2,
    text: "Access ready-to-use templates",
  },
  {
    icon: email3,
    text: "Schedule emails for later delivery",
  },
  {
    icon: email4,
    text: "Leverage Magic AI to craft personalized emails or summarize conversations",
  },
];

const SetupEmail = () => {
  const [form] = Form.useForm();
  const [subModal, setSubModal] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [email, setEmail] = useState();
  const { handleConnectEmail, handleRemove, error, setError } = useAuth();
  const subscription = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscription?.validTo);
  const isExpired = validToDate.isBefore(currentDate);
  const { emailConfiguration, isEmailConfigured, loading } =
  useContext(EmailContext);

  const onSubmit = (value) => {
    setError();
    if (!subscription?.id || isExpired) {
      setSubModal(true);
    } else {
      if (value.emailDomain === "Others") {
        setOpen(true);
        setEmail(value.email);
      } else {
        handleConnectEmail(value);
      }
    }
  };

  const inputEmail = Form.useWatch("email", form);

  useEffect(() => {
    setError();
  }, [inputEmail, setError]);

  return (
    <section className="font-roboto padd-90 h-100">
      <SubscriptionModal
        isOpen={subModal}
        handleCancel={() => setSubModal(false)}
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          {isEmailConfigured ? (
            <AccountManagement
              emailConfiguration={emailConfiguration}
              onRemove={handleRemove}
            />
          ) : (
            <>
              <SMTPEmail
                isOpen={isOpen}
                email={email}
                handleCancel={() => {
                  setOpen(false);
                  setEmail();
                }}
              />

              <div className="settings-card h-100">
                <h1
                  className="heading24px fw-bold w-100"
                  style={{ paddingBottom: 5 }}
                >
                  Streamline Your Email Communication!
                </h1>
                <div className="heading13px">
                  <p className="mt20 heading13px fw-normal">
                    Sync your email accounts and associate sales emails with
                  </p>
                  <b>deals, leads, or contacts.</b>
                  <div className="d-flex flex-column mt40" style={{ gap: 10 }}>
                    {items.map((d, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center"
                        style={{ gap: 15 }}
                      >
                        <img src={d.icon} alt="" width={20} height={20} />
                        <p className="heading13px fw-normal">{d.text}</p>
                      </div>
                    ))}
                  </div>
                  <Form
                    form={form}
                    layout="inline"
                    className="mt40 d-flex"
                    style={{ gap: 10 }}
                    onFinish={onSubmit}
                  >
                    <Form.Item
                      label="Email address"
                      name="emailDomain"
                      rules={[
                        { required: true, message: "Please select a domain" },
                      ]}
                    >
                      <Select placeholder="Select Domain">
                        <Select.Option value="Gmail">
                          <div className="heading13px d-flex align-items-center">
                            <img
                              src={gmail}
                              alt=""
                              width="15"
                              height="15"
                              className="mr-2"
                            />
                            Gmail
                          </div>
                        </Select.Option>
                        <Select.Option value="Outlook">
                          <div className="heading13px d-flex align-items-center">
                            <img
                              src={outlook}
                              alt=""
                              width="15"
                              height="15"
                              className="mr-2"
                            />
                            Outlook
                          </div>
                        </Select.Option>
                        <Select.Option value="Others">
                          <div className="heading13px d-flex align-items-center">
                            <img
                              src={smtp}
                              alt=""
                              width="15"
                              height="15"
                              className="mr-2"
                            />
                            Others
                          </div>
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please enter a valid email",
                        },
                      ]}
                    >
                      <Input
                        className="common-input"
                        style={{ width: 330 }}
                        placeholder="Donald@abctechnologies.com"
                      />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="theme-btn"
                      >
                        Connect email account
                      </Button>
                    </Form.Item>
                  </Form>
                  {error && <p className="text-error mt10 pb-2"> {error}</p>}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default SetupEmail;
